// react
import { useNavigate } from 'react-router-dom';

// components
import { SelfReferralSentPage } from '@karehero/llama/pwa/pages/SelfReferralSentPage/SelfReferralSentPage';

// hooks
import { useGoBack } from 'hooks/useGoBack';

// router
import { ROUTES } from 'router';

/**
 * SelfReferralSent wires the SelfReferralSentPage back to the portal
 */
export const SelfReferralSent = () => {
  const navigate = useNavigate();
  const goBack = useGoBack();

  return (
    <SelfReferralSentPage
      onBack={goBack}
      onDone={() => navigate(ROUTES.PORTAL, { state: { back: true } })}
    />
  );
};

export default SelfReferralSent;
